<template>
  <div id="app">
    <div id="nav">
    </div>
    <router-view/>
  </div>
</template>

<style lang="scss">

</style>
<script>
import Vue from 'vue';
import VueMeta from 'vue-meta';

Vue.use(VueMeta);

export default {
  metaInfo() {
    return {
      title: 'Poder Judicial en Números',
      meta: [
        {name: 'description', content: 'La iniciativa “Poder Judicial en Números”, corresponde a una plataforma de publicación de datos estadísticos, cuyo objeto es apertura la información pública del Poder Judicial, en formato legible, de modo de establecer una estrategia efectiva para la creación de valor público a través del análisis de información, tanto dentro como fuera de la institución. La apertura y transparencia judicial, ayudarán a mejorar el servicio de justicia, lo que tiene un resultado positivo en la vida cotidiana de las personas. Además, puede repercutir en la responsabilidad y la capacidad de las distintas unidades judiciales, para responder por sus resultados ante la sociedad y los demás poderes del Estado. En la plataforma, podrá encontrar información de la labor jurisdiccional a lo largo del país, en formato de Datos Abiertos, para el periodo comprendido entre el año 2015 – 2021. Las actualizaciones de información se realizarán de forma semestral'},
        {name: 'robots', content: 'index,follow'},
        {name: 'keywords', content: 'numero poder judicial, numero del poder judicial, poder judicial en números, poder judicial, Poder Judicial en Números, Poder Judicial, estaditicas poder judicial, datos abiertos, datos abiertos poder judicial, poder judicial chile, estadisticas poder judicial chile, sentenciados, descargas poder judicial, corte suprema chile, cifras clave' 
    }
      ],
    };
  },
};
</script>
